var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C19.1046 12 20 11.1046 20 10C20 8.89543 19.1046 8 18 8C16.8954 8 16 8.89543 16 10C16 11.1046 16.8954 12 18 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C3.10457 12 4 11.1046 4 10C4 8.89543 3.10457 8 2 8C0.89543 8 0 8.89543 0 10C0 11.1046 0.89543 12 2 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C11.1046 20 12 19.1046 12 18C12 16.8954 11.1046 16 10 16C8.89543 16 8 16.8954 8 18C8 19.1046 8.89543 20 10 20Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88997 12.65L2.94997 15.58C2.55997 15.97 2.55997 16.6 2.94997 16.99C3.33997 17.38 3.96997 17.38 4.35997 16.99L7.29997 14.06C7.68997 13.68 7.68997 13.04 7.29997 12.65C6.90997 12.26 6.27997 12.26 5.88997 12.65Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41002 2.94002C4.02002 2.55002 3.39002 2.55002 3.00002 2.94002C2.61002 3.33002 2.61002 3.96002 3.00002 4.35002L5.93002 7.29002C6.32002 7.68002 6.95002 7.68002 7.35002 7.29002C7.73002 6.90002 7.73002 6.27002 7.34002 5.88002L4.41002 2.94002Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 12.65C13.73 12.26 13.1 12.26 12.7 12.65C12.31 13.04 12.31 13.67 12.7 14.06L15.64 17C16.03 17.39 16.66 17.39 17.05 17C17.44 16.61 17.44 15.98 17.05 15.59L14.12 12.65Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.06 7.33001L17.05 4.35001C17.44 3.95001 17.44 3.32001 17.05 2.93001C16.66 2.54001 16.03 2.54001 15.64 2.93001L12.65 5.91001C12.26 6.30001 12.26 6.93001 12.65 7.33001C13.04 7.72001 13.67 7.72001 14.06 7.33001Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C11.1046 4 12 3.10457 12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2C8 3.10457 8.89543 4 10 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0b677296334a50d9d929bba3555f20f0.svg";
export { ForwardRef as ReactComponent };